export const btnSize = (size) => {
    if (size === 'sm') {
        return `
        font-size: var(--text-size-small);
        padding: 0px 4px;
        gap: 4px;
        `;
    } else if (size === 'lg') {
        return `
        font-size: var(--text-size-large);
        padding: 8px 28px;
        font-weight: 500;
        `;
    } else return ``;
};
